/**
 * @desc 获取供应商是否认证信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/getIsCertified`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
